module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.1025a6e0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-Bold.ttf
// module id = 308
// module chunks = 0